








import { Vue, Component, Prop } from "vue-property-decorator";
import { IClient } from "@/models/clients";
import { TransactionTypes } from "@/data/constants";

@Component({
  components: {
    "transactions-table": () =>
      import("@/components/app/admin/transactions/transactionsTable.vue")
  }
})
export default class AdminClientRefunds extends Vue {
  // Props
  @Prop({ required: true })
  public client!: IClient;
  // Computed
  public get transactionTypes() {
    return [
      TransactionTypes.REFUND,
      TransactionTypes.MANUAL_REFUND,
      TransactionTypes.WALLET_REFUND_OUT
    ];
  }
}
